module.exports = __webpack_public_path__ + "img/3.704881d6.jpg";